// extracted by mini-css-extract-plugin
export default {"select":"form-auto-fill_select__70282"};